import { botResponse$ } from "./chatStream";
import store from "../../../../../app/store";
import moment from "moment";
import {
  addBotMessage,
  setStreaming,
  setThreadDetails,
} from "../../../../../rtk-query/features/chatbot/chatbotSlice";
import { fetchThreadList } from "../../../../../rtk-query/features/chatbot/chatbotSidebarToolsSlice";

let isSubscribed = false;
let subscription = null;
export const initChatStreamListener = () => {
  if (isSubscribed) return;

  isSubscribed = true;

  botResponse$.subscribe((response) => {
    const resData = response?.data?.data;

    if (!resData) {
      store.dispatch(setStreaming(false));
      return;
    }

    if (resData) {
      store.dispatch(setThreadDetails(resData));
    }

    store.dispatch(
      addBotMessage({
        dateTime: moment(),
        sender: "bot",
        message:
          resData?.response ||
          resData?.message ||
          "Something went wrong",

        feedbackId: resData?.id,
        isLike: resData?.isLike ?? null,
      }),
    );

    // refresh history sidebar
    store.dispatch(
      fetchThreadList({
        isBookMark: false,
        isDeletedHistory: false,
      }),
    );

    store.dispatch(setStreaming(false));
  });
};

export const destroyChatStreamListener = () => {
  if (subscription) {
    subscription.unsubscribe();
    subscription = null;
  }
};